import { connect } from 'react-redux';
import { getIsLoggedIn, 
// getWatchCount,
getCartCount, 
// getFeedbackCount,
getNotesCount, 
// getVerificationEmailAddress,
// getCoreLevel,
// getCanUserSeeWatch,
getCurrentUserHasCore, } from '../publicSession/selectors';
import { getChatUnreadCount } from '../Chat/redux/selectors';
var mapStateToProps = function (state) { return ({
    hasCoreMembership: getCurrentUserHasCore(state),
    chatCount: getChatUnreadCount(state),
    isLoggedIn: getIsLoggedIn(state),
    noteCount: getNotesCount(state),
    cartCount: getCartCount(state),
}); };
var mapDispatchToProps = {};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SiteHeader.container.js.map